import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const NumericInputWrapper = styled.div`
  width: ${props => (props.width ? props.width : '100%')};
  height: ${props => (props.height ? props.height : '100%')};
  display: grid;
  grid-template-columns: ${props =>
    props.gridTemplateColumns ? props.gridTemplateColumns : '27fr 46fr 27fr'};
  grid-template-rows: ${props =>
    props.gridTemplateRows ? props.gridTemplateRows : ''};
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : colors.backgroundInput};
  opacity: ${props =>
    props.disabled ? '0.5' : '1'};
  border-radius: ${props =>
    props.borderRadius ? props.borderRadius : '0'};
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: ${props => props.disabled ? 0.5 : 1};
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  text-align: center;
  border: none;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : colors.backgroundInput};
  padding: 0;
  margin: 2px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.black};
  caret-color: ${colors.black};
  :hover {
    outline: none !important;
    border-radius: 2px;
    border: ${props => props.hoverColor? '1px solid ' + props.hoverColor : 'none'} !important;
    cursor: pointer;
  }
  :focus {
    outline: none !important;
    border-radius: 2px;
    border: ${props => props.selectedColor? '1px solid ' + props.selectedColor : 'none'} !important;
    caret-color: ${props => props.selectedColor? props.selectedColor : 'unset'}
  }
`;

export const Icon24 = styled.img`
  width: 24px;
  height: 24px;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover {
    box-shadow: ${props => {
      if (props.disabled) {
        return 'none';
      } else {
        if (props.hoverBoxShadow) {
          return '0 2px 4px 0 rgba(0, 0, 0, 0.15)';
        }
        return 'none';
      }
    }};
  };

  &:active {
    box-shadow: unset;
    stroke: ${colors.black};
  }
`;
